export default "__VITE_ASSET__B3r64r6N__"